// extracted by mini-css-extract-plugin
export default {"SecondaryAccountUnauthorizedError":"ProtectedRoute_SecondaryAccountUnauthorizedError__5wR8E","Dimmer":"ProtectedRoute_Dimmer__XIpiF"};